import { Box, Button, TextField, Typography } from "@mui/material"
import { DashboardModal } from "./DashboardModal"
import {useDispatch, useSelector} from "react-redux"
import { selectUser } from "../../reducers/userSlice"
import { useState } from "react"
import axios from "axios"
import { useSnackbar } from "notistack"
import { selectOpenContact, closeContactModal} from "../../reducers/dashboardModalControlSlice"

export default function ContactSupport() {
	const openSupportModal = useSelector(selectOpenContact)
	const dispatch = useDispatch()

	return (
		<DashboardModal
			open={openSupportModal}
			setClose={() => dispatch(closeContactModal())}
			title={"Contact Support"}
		>
			<Typography variant={"body1"}>
				Please describe the problem you're experiencing below. If you know them,
				please include your OS and browser information. A member of the support
				staff will respond to you as soon as possible.
			</Typography>
			<EmailForm
				subject={"support"}
				placeholder={"What's the issue?"}
				close={() => dispatch(closeContactModal())}
			/>
		</DashboardModal>
	)
}

export function EmailForm({ subject, placeholder, close }) {
	const user = useSelector(selectUser)
	const [message, setMessage] = useState("")
	const { enqueueSnackbar } = useSnackbar()

	const handleChange = (evt) => {
		setMessage(evt.target.value)
	}

	const handleSend = () => {
		const messageToSend = {
			subject: `[${subject}] request from ${user.email} - ${user.firstName} ${user.lastName}`,
			body: message,
		}
			
		axios
			.post("/api/email/contact-support", messageToSend)
			.then(() => {
				setMessage("ok")
				enqueueSnackbar("Message sent!", { variant: "info" })
			})
			.catch(error => {
				console.error(error)
				enqueueSnackbar("Something went wrong. Please try again.", { variant: "error" })
			})
			.finally(() => {
				close()
			})
	}
	

	return (
		<Box>
			<TextField
				multiline
				fullWidth
				rows={10}
				label={placeholder}
				sx={{ margin: "16px 0" }}
				value={message}
				onChange={handleChange}
			/>
			<Button onClick={handleSend} variant={"contained"} color={"primary"}>
				Send
			</Button>
		</Box>
	)
}
